// src/components/CreatorTopMenuBar.jsx
// Note: Component name kept for file compatibility; renders "Author" in UI
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const CreatorTopMenuBar = () => {
  const location = useLocation();

  const menuItems = [
    { label: 'Author Home', path: '/author' },
    { label: 'Author Console', path: '/author-console' },
    { label: 'Analytics', path: '/author/analytics' },
    { label: 'Promotions', path: '/author/promotions' },
  ];

  // Filter out the current page link (smart hiding)
  const visibleItems = menuItems.filter(item => {
    // Exact match for dashboard - handle both /author and legacy /creator
    if ((item.path === '/author') && 
        (location.pathname === '/author' || location.pathname === '/creator')) {
      return false;
    }
    // Match for console routes - handle both canonical and legacy
    if (item.path === '/author-console' && 
        (location.pathname === '/author-console' || location.pathname === '/creator-console')) {
      return false;
    }
    // Match for other routes - handle both /author/* and legacy /creator/*
    const canonicalPath = item.path;
    const legacyPath = item.path.replace('/author', '/creator');
    if (canonicalPath !== '/author' && canonicalPath !== '/author-console') {
      if (location.pathname.startsWith(canonicalPath) || location.pathname.startsWith(legacyPath)) {
        return false;
      }
    }
    return true;
  });

  return (
    <div className="sticky top-[4.5rem] md:top-[5.5rem] z-40 border-b border-slate-800 bg-slate-950/95 backdrop-blur">
      <div className="mx-auto max-w-7xl px-3">
        <div className="flex flex-wrap justify-center items-center gap-2 py-2">
          {visibleItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="rounded-full px-4 py-1.5 text-sm font-medium text-slate-300 hover:bg-purple-900/30 hover:text-purple-300 transition-colors"
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CreatorTopMenuBar;
